const styles = (props) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    borderRadius: "12px",
    position: "relative",
    bgcolor: "background.default",
    maxWidth: "77.6vw",
    maxHeight: "80vh",
    overflow: "auto",
    backgroundColor: props.palette.background.paper,
    borderRadius: 3,
  },
  header: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    with: 1,
  },
  avatar: { width: "50px", height: "50px" },
  headerContent: {
    display: "flex",
    flexDirection: "column",
    p: 3,
    pt: "2px",
  },
  headerLine: { display: "flex", flexDirection: "row", gap: 1 },
  headerItem: { display: "flex", flexDirection: "column", width: "160px" },
  headerSubtitle: { opacity: 0.6, fontSize: "13px", fontWeight: 500 },
  headerText: {
    fontSize: "15px",
    fontWeight: 500,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    padding: "20px 20px 20px 20px",
    gap: 2,
  },
  contentHeader: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    position: "relative",
    justifyContent: "space-between",
  },
  boxMap: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    flexWrap: "wrap",
  },
  boxTextField: { minWidth: "200px" },
});

export default styles;
